import React, { useState } from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const ChangeValidity = () => {
    const [username, setUsername] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [role, setRole] = useState('');
    const [date, setDate] = useState(null);
    const navigate = useNavigate();

    const handleClose = () => {
        navigate('/users');
    };

    const handleUpdate = async () => {
        if (!username || !date) {
            alert('Please fill in username and validity date.');
            return;
        }

        const formattedDate = dayjs(date).format('YYYY-MM-DD');

        const payload = {
            username,
            name,
            email,
            phone,
            role,
            validity: formattedDate,
        };

        console.log('Sending payload:', payload);

        try {
            const response = await axios.post(
                'https://d3ioa5kdb9.execute-api.ap-south-1.amazonaws.com/Tis_whatsapp_be/account_control',
                payload
            );
            console.log('Response:', response.data);
            alert('✅ Validity updated successfully!');
            navigate('/users');
        } catch (error) {
            console.error('Error updating validity:', error);
            alert('❌ Failed to update validity.');
        }
    };

    return (
        <Box
            sx={{
                width: 400,
                mx: 'auto',
                mt: 4,
                p: 3,
                borderRadius: 2,
                boxShadow: 1,
                backgroundColor: '#fff',
                position: 'relative',
            }}
        >
            <IconButton
                onClick={handleClose}
                sx={{ position: 'absolute', top: 8, right: 8, color: 'gray' }}
            >
                <CloseIcon />
            </IconButton>

            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 3, color: '#1a237e' }}>
                Update User Details
            </Typography>

            <TextField
                label="Username"
                fullWidth
                size="small"
                variant="outlined"
                sx={{ mb: 2 }}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
            />

            <TextField
                label="Name"
                fullWidth
                size="small"
                variant="outlined"
                sx={{ mb: 2 }}
                value={name}
                onChange={(e) => setName(e.target.value)}
            />

            <TextField
                label="Email ID"
                fullWidth
                size="small"
                variant="outlined"
                sx={{ mb: 2 }}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />

            <TextField
                label="Phone Number"
                fullWidth
                size="small"
                variant="outlined"
                sx={{ mb: 2 }}
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
            />

            <TextField
                label="Role"
                fullWidth
                size="small"
                variant="outlined"
                sx={{ mb: 2 }}
                value={role}
                onChange={(e) => setRole(e.target.value)}
            />

            <Typography variant="body2" sx={{ mb: 0.5 }}>
                Validity Date (existing):
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    format="DD-MM-YYYY"
                    value={date}
                    onChange={(newValue) => setDate(newValue)}
                    slotProps={{ textField: { size: 'small', fullWidth: true } }}
                />
            </LocalizationProvider>

            <Button
                onClick={handleUpdate}
                variant="contained"
                sx={{
                    marginTop: 2,
                    background: 'linear-gradient(to right, #0052D4, #4364F7, #6FB1FC)',
                    color: '#fff',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    borderRadius: 2,
                    py: 1,
                    fontSize: '1rem',
                    boxShadow: '0 4px 12px rgba(0, 82, 212, 0.4)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        transform: 'scale(1.03)',
                        boxShadow: '0 6px 16px rgba(67, 100, 247, 0.5)',
                        background: 'linear-gradient(to right, #003cbd, #3451e0, #5e96f5)',
                    },
                }}
            >
                🚀 Update
            </Button>
        </Box>
    );
};

export default ChangeValidity;
